export const enChannels = {
  AdomainEnrichment: 'Adomain Enrichment',
  AdomainEnrichmentTooltipText: 'Uses a machine learning model to determine the adomain of the mediafile based on the ad in the bid response.',
  AdQualityTools: 'Ad Quality Tools',
  AdQualityToolsWithAsterisk: 'Ad Quality Tools *',
  AdQualityToolsText: 'Maintain high ad quality and maximize revenue with our Ad Quality tools included in the standard pricing plan. For advanced Elea AI powered features that further enhance these capabilities, please contact your account manager to explore options.',
  ChannelsTextInputNameSelectChannelsAddLabels: 'Input name, select channels, and add labels.',
  ClickThroughAdomainRecognitionEnabledName: 'Advertiser Domain Recognition from Click-Through URL',
  ClickThroughAdomainRecognitionEnabledTooltipText: 'Attempts to enrich the adomain using the click-through URL, if available in the bid response.',
  Codec: 'Codec',
  CreativeQualityAssurance: 'Creative Quality Assurance',
  CreativeQualityAssuranceTooltipText1: 'Validates and adjusts your advertising creatives to meet the requirements and constraints of different channels/inventory.',
  CreativeQualityAssuranceTooltipText2: 'CQA offers publishers various benefits:',
  CreativeQualityAssuranceTooltipText3: "Blocks creatives that don't adhere to the Audio/Video spec specified at the channel level",
  CreativeQualityAssuranceTooltipText4: 'Enhances ad delivery quality and efficiency by re-transcoding creatives to match technical specifications',
  CreativeQualityAssuranceTooltipText5: 'Reports comprehensively on creative performance, compliance, and optimization',
  DisabledFeatureText: 'To get access, please contact your account manager.',
  LanguageEnrichment: 'Language Enrichment',
  LanguageEnrichmentTooltipText: 'Uses a machine learning model to identify the language of the mediafile by analyzing the ad in the bid response.',
  MinimumAudioBitrate: 'Minimum Audio Bitrate',
  MinimumFrameRate: 'Minimum Frame Rate',
  MinimumSamplingFrequency: 'Minimum Sampling Frequency',
  MinimumVideoBitrate: 'Minimum Video Bitrate',
  MinimumVideoResolution: 'Minimum Video Resolution',
  Premium: 'Premium',
  PremiumFeatureDescription1: 'Powered by Elea AI, unlock advanced ad performance by activating Adomain Enrichment, Language Enrichment, and Creative Quality Assurance.',
  PremiumFeatureDescription2: 'Use them individually or together for a comprehensive solution.',
  PublicaVault: 'Publica Vault',
  PublicaVaultToolText: 'Please contact your Account Manager to enable this feature.',
  Standard: 'Standard',
  StandardFeatureDescription: 'Includes all essential tools that use declared metadata to support ad performance.',
  WebShrinkerCategoryEnabledName: 'IAB Category Mapping',
  WebShrinkerCategoryEnabledTooltipText: 'Enriches the IAB category by mapping the adomain in the bid response.',
  VideoFormat: 'Video Format'
};
